import { render, staticRenderFns } from "./OuttripEquipement.vue?vue&type=template&id=3823c217&scoped=true&"
import script from "./OuttripEquipement.vue?vue&type=script&lang=js&"
export * from "./OuttripEquipement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3823c217",
  null
  
)

export default component.exports